/**
 * Ovani storefront search logging for Demand Intelligence.
 * Configure worker URL + token via theme settings or defaults below.
 */
(function () {
  const WORKER_URL = window.OVANI_DEMAND_INTEL_URL || "";
  const INGEST_TOKEN = window.OVANI_DEMAND_INTEL_TOKEN || "";
  if (!WORKER_URL) return;

  const seen = new Set();
  const DEBOUNCE_MS = 800;

  function sendQuery(query) {
    const q = String(query || "").trim();
    if (q.length < 2 || seen.has(q.toLowerCase())) return;
    seen.add(q.toLowerCase());

    fetch(WORKER_URL.replace(/\/$/, "") + "/ingest/search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(INGEST_TOKEN ? { "X-Ingest-Token": INGEST_TOKEN } : {}),
      },
      body: JSON.stringify({
        query: q,
        path: location.pathname,
        timestamp: new Date().toISOString(),
        source: "storefront",
      }),
      keepalive: true,
    }).catch(function () {});
  }

  function hookInput(input) {
    if (!input || input.dataset.ovaniIntelHooked) return;
    input.dataset.ovaniIntelHooked = "1";
    let timer;
    input.addEventListener("input", function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        sendQuery(input.value);
      }, DEBOUNCE_MS);
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") sendQuery(input.value);
    });
  }

  function scan() {
    document
      .querySelectorAll('input[type="search"], input[name="q"], .search__input')
      .forEach(hookInput);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
